import styled, { css } from "styled-components";

const StyledStoreCard = styled.div`
  ${({ theme }) => {
    return css`
      position: relative;
      margin-top: 100px;
      max-width: 640px;
      min-width: 320px;

      a {
        text-decoration: none;
      }

      .warning-icon {
        margin-right: ${theme.spacing(1)}px;
      }

      .card-header {
        flex-direction: row;

        .close-button {
          padding: 0;
        }

        & div:first-child {
          margin-right: ${theme.spacing(3)}px;
        }
      }
      .card-content {
        min-height: 80px;
        background: rgb(250, 250, 250);
        position: relative;
      }
    `;
  }}
`;

export default StyledStoreCard;
